import { api } from '../../App'

export const sendOrderStatus = data => {
  const { restid, id } = data

  return api.put(`/order/${restid}/orderrow/${id}/finished`)
}
